import React from "react";
import { Row, Col, Form, Modal, Button } from "react-bootstrap";
import SignaturePad from "react-signature-canvas";
import { connect } from "react-redux";
import {
  getContactsActions,
  getUserRolesAction,
} from "../../actions/UserActions";
import {
  getAllTransactionsAction,
  getAllTasksAction,
  createTaskAction,
} from "../../actions/TransactionActions";
import { getVendorTransactionsAction } from "../../actions/VendorTransactionActions";
import { getBuyerTransactionsAction } from "../../actions/BuyerTransactionActions";
import { addDocAction, uploadDocumentAction } from "./../../actions/DocActions";
import { addPublicFormAction } from "../../actions/PublicFormsActions";
import {
  formatPhoneNumber,
  toastMessage,
  cryptoTokenDecode,
  convertTimeToMinutes,
  getContingencyData,
  checkObjExists,
} from "../Common/Common";
import moment from "moment";
import html2pdf from "html2pdf.js";
import * as code from "./../../config/Constants";
import * as message from "./../../config/CommonMessages";
import StickyHeader from "./StickyHeader";
import { HelpOutline } from "@material-ui/icons";
import FormActionPrompt from "./FormActionPrompt";
import InputMask from "react-input-mask";
import GenerateQRcode from "./GenerateQRcode";
var _ = require("lodash");

class ConsentForm extends React.Component {
  constructor(props) {
    super(props);
    var userType = cryptoTokenDecode().usertype;
    let currentType = localStorage.getItem("currentRole");
    let studioName = localStorage.getItem("companyName");
    this.state = {
      contacts: [],
      transactions: [],
      transaction: {},
      events: [],
      contingencies: [],
      appointmentDate: "",
      transactionId: "",
      userType: userType.toUpperCase(),
      studioName: !!studioName ? studioName.toUpperCase() : "",
      currentRole: !!currentType ? currentType.toUpperCase() : "",
      showPrompt: false,
      promptType: "",
      selectedTransClientEmail: "",
      showQRcodePrompt: false,
      errors: {},
      listedTransactions: [],
      showLoader: false,
    };
    this.exportFormToPDF = this.exportFormToPDF.bind(this);
  }

  componentWillMount() {
    this.getAllTransactions();
  }

  handleTransactionSelection(e) {
    if (e) {
      this.setState({
        transaction: e,
        transactionId: e.id,
        contingencies: e.contingencies,
        selectedTransClientEmail: e.hasGuardian
          ? e.guardianEmail
          : e.clientEmail,
        errors: {},
      });
    }

    this.getAllTasks(e.id);
  }

  clearTransactionSelection() {
    this.handleClosePrompt();
    this.setState({
      transaction: {},
      errors: {},
    });
  }

  handleShowPrompt(name) {
    this.setState({
      showPrompt: true,
      promptType: name,
    });
  }

  handleClosePrompt() {
    this.setState({
      showPrompt: false,
      promptType: "",
    });
  }

  handleShowQRcodePrompt() {
    this.setState({
      showQRcodePrompt: true,
    });
  }

  handleCloseQRcodePrompt() {
    this.setState({
      showQRcodePrompt: false,
    });
  }

  getAllTransactions(id) {
    this.setState({ showLoader: true });
    if (
      this.state.userType === message.VENDOR &&
      this.state.currentRole === message.BUYERAGENT
    ) {
      this.props.getVendorTransactionsAction().then((vendorRes) => {
        this.setState(
          {
            transactions: this.props.vendorTransactions.data || [],
            showLoader: false,
          },
          () => {
            this.getFilteredTransactions();
          }
        );
      });
    } else if (
      this.state.userType === message.BUYER &&
      this.state.currentRole === message.BUYER
    ) {
      this.props.getBuyerTransactionsAction().then((buyerRes) => {
        this.setState(
          {
            transactions: this.props.buyerTransactions.data || [],
            showLoader: false,
          },
          () => {
            this.getFilteredTransactions();
          }
        );
      });
    } else {
      this.props.getAllTransactionsAction("INPROGRESS").then((res) => {
        this.setState(
          {
            transactions: this.props.transactions.data || [],
            showLoader: false,
          },
          () => {
            this.getFilteredTransactions();
          }
        );
      });
    }
  }

  getFilteredTransactions() {
    let transactions = this.state.transactions;
    let listedTransactions = [];

    for (let i = 0; i < transactions.length; i++) {
      listedTransactions.push({
        label:
          transactions[i].shortName +
          " - " +
          transactions[i].dsd.buyer[0].firstname +
          (transactions[i].dsd.buyer[0].lastname
            ? " " + transactions[i].dsd.buyer[0].lastname
            : ""),
        id: transactions[i]._id,
        clientFirstName: transactions[i].dsd.buyer[0].firstname,
        clientLastName: transactions[i].dsd.buyer[0].lastname
          ? transactions[i].dsd.buyer[0].lastname
          : "",
        clientEmail: transactions[i].dsd.buyer[0].email,
        clientPhone: transactions[i].dsd.buyer[0].mobileNumber,
        guardianName: transactions[i].dsd.closingAgents[0]
          ? transactions[i].dsd.closingAgents[0].firstname +
            (transactions[i].dsd.closingAgents[0].lastname
              ? " " + transactions[i].dsd.closingAgents[0].lastname
              : "")
          : "",
        guardianEmail: transactions[i].dsd.closingAgents[0]
          ? transactions[i].dsd.closingAgents[0].email
          : "",
        guardianPhone: transactions[i].dsd.closingAgents[0]
          ? transactions[i].dsd.closingAgents[0].mobileNumber
          : "",
        contingencies: transactions[i].contingencies,
        status: transactions[i].status,
        hasGuardian:
          transactions[i].dsd.closingAgents.length !== 0 ? true : false,
        shortName: transactions[i].shortName,
        description: transactions[i].dsd.heldBy,
      });
    }

    this.setState({
      listedTransactions: listedTransactions,
    });

    if (this.props.history.location.createdTrans) {
      let defOption = listedTransactions.find(
        (option) => option.id === this.props.history.location.createdTrans._id
      );
      this.handleTransactionSelection(defOption);
    }
  }

  getAllTasks(id) {
    this.props.getAllTasksAction(id).then((res) => {
      this.setState({
        events: this.props.tasks.data,
      });
    });
  }

  async exportFormToPDF(promptType) {
    this.handleClosePrompt();

    let form = document.getElementById("formToExport");

    let transId = this.state.transactionId;

    //Setup the filename
    const dt = new Date();
    let filestamp =
      "_" +
      dt.getFullYear().toString() +
      (dt.getMonth() + 1).toString() +
      dt.getDate().toString() +
      dt.getHours().toString() +
      dt.getMinutes().toString() +
      dt.getSeconds().toString();

    let clientFullName =
      this.state.transaction.clientFirstName.trim() +
      (this.state.transaction.clientLastName
        ? " " + this.state.transaction.clientLastName.trim()
        : "");

    let fileName =
      "consent" +
      (clientFullName ? "_" + clientFullName : "") +
      filestamp +
      ".pdf";
    let fn = fileName.split(" ").join("_");

    //Set the pdf Export Options
    let opt = {
      margin: 1.5,
      filename: fn,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2.5, width: 1000 },
      jsPDF: { unit: "in", format: "a1", orientation: "p" },
    };

    //Begin the fileupload setup
    var documents = [];
    var docDetail = {};

    //Exports the file to a blob
    const blob = await html2pdf()
      .set(opt)
      .from(form)
      .toPdf()
      .output("blob", fn);

    //Set the file details for the insert into the ducuments colection
    docDetail = {
      fileName: fn,
      size: (blob.size / (1024 * 1024)).toFixed(2),
    };
    documents.push(docDetail);

    var dataToPost = {
      transactionId: transId,
      location: "Transaction Docs",
      document: documents,
    };

    //Setup the formdata for the fileupload to s3
    var formData = new FormData();
    formData.append("file", blob, fn);

    //addDocAction writes the mongodb record about the file and returns the unique file name that will be stored in 33
    this.props.addDocAction(dataToPost).then((res) => {
      if (res.status === code.OK) {
        var fileUploadName = "";
        res.data.map((item) => {
          if (fileUploadName.length > 0) {
            fileUploadName +=
              "@@@" + item.document + "###" + item.uploadedFileName;
          } else {
            fileUploadName = item.document + "###" + item.uploadedFileName;
          }
          //uploadDocumentAction actually sends the file to S3
          this.props
            .uploadDocumentAction(formData, transId, undefined, fileUploadName)
            .then((isValidDoc) => {
              // console.log("VALID");
              //Export the file for download
              html2pdf()
                .set(opt)
                .from(form)
                .save();
            });

          if (promptType === "uploadAndOpenIntake") {
            this.props.history.push({
              pathname: "/intake",
              createdTrans: { _id: transId },
            });
          }
        });
      } else {
        //console.log("BAD addDocAction Status: " + res.status);
        toastMessage(code.ERROR, res.data);
      }
    });
  }

  sendForm(transId) {
    let transaction = this.state.transaction;
    let senderEmailToken =
      transaction && transaction.hasGuardian
        ? {
            email: "@guardian_email",
            firstname: "@guardian_firstname",
            lastname: "@guardian_lastname",
            dataValue: "guardian_firstname",
            contingency: "Guardian",
          }
        : transaction.clientEmail
        ? {
            email: "@client_email",
            firstname: "@client_firstname",
            lastname: "@client_lastname",
            dataValue: "client_firstname",
            contingency: "Client",
          }
        : "";
    let senderPhoneToken =
      transaction && transaction.hasGuardian
        ? {
            phone: "@guardian_phone",
            phoneValue: transaction.guardianPhone,
            firstname: "@guardian_firstname",
            lastname: "@guardian_lastname",
            contingency: "Guardian",
          }
        : transaction.clientPhone
        ? {
            phone: "@client_phone",
            phoneValue: transaction.clientPhone,
            firstname: "@client_firstname",
            lastname: "@client_lastname",
            contingency: "Client",
          }
        : "";

    this.handleClosePrompt();

    let newEventStart = moment();
    let newEventEnd = moment();
    let newEventTime = convertTimeToMinutes(
      moment(newEventStart).get("hour") +
        ":" +
        moment(newEventStart).get("minutes")
    );

    let appointmentDate = getContingencyData(
      this.state.contingencies,
      "First Appointment",
      "startDate"
    );

    let newPublicForm = {
      form: "consent",
      transactionId: transId,
      expiresOn: new Date(moment(appointmentDate).subtract(5, "days")),
      auth: false,
    };
    this.props.addPublicFormAction(newPublicForm).then((newPubResConsent) => {
      //   console.log(
      //     "PUBLIC FORM addPublicFormAction consent res: ",
      //     newPubResConsent
      //   );
    });

    let newEvent = {
      assignee: "",
      campaign: "",
      communicationSubject: [
        `Consent Form for ${senderEmailToken.firstname} ${
          senderEmailToken.lastname
        }`,
      ],
      communicationTo: [senderEmailToken.email],
      communicationType: "EMAIL",
      contingency: senderEmailToken.contingency,
      day: 0,
      description: [
        `<p>Hey <a href="" class="wysiwyg-mention" data-mention="" data-value="${
          senderEmailToken.dataValue
        }">${
          senderEmailToken.firstname
        }</a>!</p><p></p><p>The consent form for your appointment on @first_appointment_date is available at the link below. Just copy and paste it into your browser. Please complete and submit it as soon as possible. Thanks!</p><p></p><p>@consent_form_url</p>`,
      ],
      document: false,
      eventEndDate: newEventEnd,
      eventStartDate: newEventStart,
      eventType: "COMMUNICATION",
      isReminder: false,
      reminderDate: "",
      reminderTime: 540,
      specialTask: [""],
      status: "SCHEDULED",
      time: newEventTime,
      timeZone: "240",
      title: "Consent Form - Email",
      transactionId: transId,
    };

    if (newEvent.eventEndDate && newEvent.eventStartDate && newEvent.time) {
      this.props.createTaskAction(newEvent).then((createEventRes) => {
        if (createEventRes.status === code.OK) {
          toastMessage(code.SUCCESS, "Form sent");
          //   console.log(createEventRes);
        }
      });
    }

    if (senderPhoneToken.phoneValue) {
      newEvent = {
        assignee: "",
        campaign: "",
        communicationSubject: [""],
        communicationTo: [senderPhoneToken.phone],
        communicationType: "TEXT",
        contingency: "First Appointment",
        day: 0,
        description: [
          `Hey ${
            senderPhoneToken.firstname
          }! We emailed you the consent form for your appointment on @first_appointment_date. Please complete and submit it as soon as possible. Thanks!`,
        ],
        document: false,
        eventEndDate: newEventEnd,
        eventStartDate: newEventStart,
        eventType: "COMMUNICATION",
        isReminder: false,
        reminderDate: "",
        reminderTime: 540,
        specialTask: [""],
        status: "SCHEDULED",
        time: newEventTime,
        timeZone: "240",
        title: "Consent Form - Text",
        transactionId: transId,
      };

      if (newEvent.eventEndDate && newEvent.eventStartDate && newEvent.time) {
        this.props.createTaskAction(newEvent).then((createEventRes) => {
          if (createEventRes.status === code.OK) {
            //   console.log(createEventRes);
          }
        });
      }
    }
  }

  handleChange = (e, key) => {
    if (
      this.state.transaction &&
      Object.keys(this.state.transaction).length > 0
    ) {
      this.setState({
        transaction: {
          ...this.state.transaction,
          [key]: e.target.value,
        },
      });
    }
  };

  errorHandler(errors) {
    this.setState({
      errors: errors,
    });
  }

  render() {
    let transaction = this.state.transaction;
    let events = this.state.events;
    if (this.state.showLoader) {
      return (
        <div className="page-loader fixed">
          <div className="page-loader-inner">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="admin-steps admin-content-area">
          <StickyHeader
            listedTransactions={this.state.listedTransactions}
            transaction={this.state.transaction}
            handleTransactionSelection={this.handleTransactionSelection.bind(
              this
            )}
            clearTransactionSelection={this.clearTransactionSelection.bind(
              this
            )}
            handleShowPrompt={this.handleShowPrompt.bind(this)}
            selectedTransClientEmail={this.state.selectedTransClientEmail}
            handleShowQRcodePrompt={this.handleShowQRcodePrompt.bind(this)}
            formType="consent"
            errorHandler={this.errorHandler.bind(this)}
          />
          <div className="container-custom">
            <Form className="form-sm form-admin" id="formToExport">
              <Row>
                <Col xs={12} sm={7}>
                  <Row>
                    <Col xs={12}>
                      <h3 className="title-medium font-600 mt-2 mb-3 pt-3">
                        Tattoo Consent Form
                      </h3>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={6}>
                  <p>
                    In consideration of receiving a tattoo from{" "}
                    {this.state.studioName} including its artists, associates,
                    apprentices, agents, or any employees (hereinafter referred
                    to as the “Tattoo Studio”) I agree to the following:
                  </p>
                  <Form.Group>
                    <Form.Label>
                      I have have been fully informed of the risks associated
                      with getting a tattoo. I fully understand that these
                      risks, known and unknown, can lead to injury including but
                      not limited to: infection, scarring, difficulties in the
                      detection of melanoma and allergic reactions to tattoo
                      pigment, aftercare products and/or soap. Having been
                      informed of the potential risks associated with getting a
                      tattoo I wish to proceed with the tattoo procedure and
                      application and freely accept and expressly assume any and
                      all risks that may arise from tattooing.
                    </Form.Label>
                    <Form.Control className="w-25" />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>
                      I WAIVE AND RELEASE to the fullest extent permitted by law
                      any person of the Tattoo Studio from all liability
                      whatsoever, including but not limited to, any and all
                      claims or causes of action that I, my estate, heirs,
                      executors or assigns may have for personal injury or
                      otherwise, including any direct and/or consequential
                      damages, which result or arise from the procedure and
                      application of my tattoo, whether caused by the negligence
                      or fault of either the Tattoo Studio, or otherwise.
                    </Form.Label>
                    <Form.Control className="w-25" />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col xs={12} sm={6}>
                  <Form.Group>
                    <Form.Label>
                      The Tattoo Studio has given me instructions on the care of
                      my tattoo while it's healing. I understand and will follow
                      them. I acknowledge that it is possible that the tattoo
                      can become infected, particularly if I do not follow the
                      instructions given to me. If any touch-up work to the
                      tattoo is needed due to my own negligence, I agree that
                      the work will be done at my own expense.
                    </Form.Label>
                    <Form.Control className="w-25" />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>
                      I am not under the influence of alcohol or drugs, and I am
                      voluntarily submitting to be tattooed by the Tattoo Studio
                      without duress or coercion.
                    </Form.Label>
                    <Form.Control className="w-25" />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col xs={12} sm={6}>
                  <Form.Group>
                    <Form.Label>
                      I am not currently pregnant nor do I have reason to
                      believe that I might be currently pregnant.
                    </Form.Label>
                    <Form.Control className="w-25" />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>
                      The Tattoo Studio is not responsible for the meaning or
                      spelling of the symbol or text that I have provide to them
                      or chosen from the flash (design) sheets.
                    </Form.Label>
                    <Form.Control className="w-25" />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col xs={12} sm={6}>
                  <Form.Group>
                    <Form.Label>
                      Variations in color and design may exist between the
                      tattoo art I have selected and the actual tattoo when it
                      is applied to my body. I also understand that over time,
                      the colors and the clarity of my tattoo will fade due to
                      unprotected exposure to the sun and the naturally
                      occurring dispersion of pigment under the skin.
                    </Form.Label>
                    <Form.Control className="w-25" />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>
                      A tattoo is a permanent change to my appearance and can
                      only be removed by laser or surgical means, which can be
                      disfiguring and/or costly and which in all likelihood will
                      not result in the restoration of my skin to its exact
                      appearance before being tattooed.
                    </Form.Label>
                    <Form.Control className="w-25" />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col xs={12} sm={6}>
                  <Form.Group>
                    <Form.Label>
                      I release the right to any photographs taken of me and the
                      tattoo and give consent in advance to their reproduction
                      in print or electronic form. (For assurance, if you do not
                      initial this provision, please inform the Tattoo Studio
                      NOT to take any pictures of you and your completed
                      tattoo).
                    </Form.Label>
                    <Form.Control className="w-25" />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>
                      I acknowledge that I have been given adequate opportunity
                      to read and understand this document that it was not
                      presented to me at the last minute and grasp that I am
                      signing a legal contract waiving certain rights to recover
                      damages against the Tattoo Studio.
                    </Form.Label>
                    <Form.Control className="w-25" />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>
                      I agree to IMMEDIATELY notify the artist if I feel
                      lightheaded, dizzy and/or faint before, during or after
                      the procedure. Failure to do so releases the Tattoo Studio
                      and my tattoo artist of all responsibility.
                    </Form.Label>
                    <Form.Control className="w-25" />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col xs={12} sm={6}>
                  <p>
                    If any provision, section, subsection, clause or phrase of
                    this release is found to be unenforceable or invalid, that
                    portion shall be severed from this contract. The remainder
                    of this contract will then be construed as though the
                    unenforceable portion had never been contained in this
                    document.
                  </p>

                  <p>
                    I hereby declare that I am of legal age (and have provided
                    valid proof of age and identification) and am competent to
                    sign this Agreement.
                  </p>

                  <p>
                    I HAVE READ THE AGREEMENT, I UNDERSTAND IT, AND I AGREE TO
                    BE BOUND BY IT.
                  </p>

                  <p>
                    **PLEASE ASK YOUR ARTIST ABOUT THE PRICE OF YOUR TATTOO
                    BEFORE BEGINNING THE PROCEDURE - it is your responsibility
                    to confirm the price of the tattoo, and we assume no
                    responsibility for any misunderstanding in this regard.
                  </p>
                </Col>
              </Row>

              <Row>
                <Col xs={12} sm={3}>
                  <Form.Group>
                    <Form.Label>
                      Client First Name<span className="text-danger"> *</span>:
                    </Form.Label>
                    <Form.Control
                      onChange={(e) => this.handleChange(e, "clientFirstName")}
                      value={
                        checkObjExists(transaction)
                          ? transaction.clientFirstName
                          : ""
                      }
                      isInvalid={!!this.state.errors.clientFirstName}
                    />
                    <Form.Control.Feedback type="invalid">
                      {this.state.errors.clientFirstName}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} sm={3}>
                  <Form.Group>
                    <Form.Label>Client Last Name:</Form.Label>
                    <Form.Control
                      onChange={(e) => this.handleChange(e, "clientLastName")}
                      value={
                        checkObjExists(transaction)
                          ? transaction.clientLastName
                          : ""
                      }
                      isInvalid={!!this.state.errors.clientLastName}
                    />
                    <Form.Control.Feedback type="invalid">
                      {this.state.errors.clientLastName}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={3}>
                  <Form.Group>
                    <Form.Label>Client Email:</Form.Label>
                    <Form.Control
                      type="email"
                      onChange={(e) => this.handleChange(e, "clientEmail")}
                      value={
                        checkObjExists(transaction)
                          ? transaction.clientEmail
                          : ""
                      }
                      isInvalid={!!this.state.errors.clientEmail}
                    />
                    <Form.Control.Feedback type="invalid">
                      {this.state.errors.clientEmail}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} sm={3}>
                  <Form.Group>
                    <Form.Label>Client Mobile Number:</Form.Label>
                    <InputMask
                      mask="999-999-9999"
                      maskChar=""
                      formControlProps={{
                        fullWidth: true,
                      }}
                      onChange={(e) => this.handleChange(e, "clientPhone")}
                      value={
                        checkObjExists(transaction)
                          ? formatPhoneNumber(transaction.clientPhone)
                          : ""
                      }
                      name="clientPhone"
                    >
                      {(inputProps) => <Form.Control {...inputProps} />}
                    </InputMask>
                    {this.state.errors.clientPhone && (
                      <div
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      >
                        {this.state.errors.clientPhone}
                      </div>
                    )}
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={3}>
                  <Form.Group>
                    <Form.Label>Date:</Form.Label>
                    <Form.Control value={moment().format("MM/DD/YYYY")} />
                  </Form.Group>
                </Col>
              </Row>
              {transaction.hasGuardian ? (
                <>
                  <Row>
                    <Col xs={12} sm={3}>
                      <Form.Group>
                        <Form.Label>
                          Guardian Name<span className="text-danger"> *</span>:
                        </Form.Label>
                        <Form.Control
                          value={
                            checkObjExists(transaction)
                              ? transaction.guardianName
                              : ""
                          }
                          onChange={(e) => this.handleChange(e, "guardianName")}
                          isInvalid={!!this.state.errors.guardianName}
                        />
                        <Form.Control.Feedback type="invalid">
                          {this.state.errors.guardianName}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col xs={12} sm={3}>
                      <Form.Group>
                        <Form.Label>Guardian Email:</Form.Label>
                        <Form.Control
                          value={
                            checkObjExists(transaction)
                              ? transaction.guardianEmail
                              : ""
                          }
                          type="email"
                          onChange={(e) =>
                            this.handleChange(e, "guardianEmail")
                          }
                          isInvalid={!!this.state.errors.guardianEmail}
                        />
                        <Form.Control.Feedback type="invalid">
                          {this.state.errors.guardianEmail}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} sm={3}>
                      <Form.Group>
                        <Form.Label>Guardian Mobile Number:</Form.Label>

                        <InputMask
                          mask="999-999-9999"
                          maskChar=""
                          formControlProps={{
                            fullWidth: true,
                          }}
                          onChange={(e) =>
                            this.handleChange(e, "guardianPhone")
                          }
                          value={
                            checkObjExists(transaction)
                              ? formatPhoneNumber(transaction.guardianPhone)
                              : ""
                          }
                          name="guardianPhone"
                        >
                          {(inputProps) => <Form.Control {...inputProps} />}
                        </InputMask>
                        {this.state.errors.guardianPhone && (
                          <div
                            className="invalid-feedback"
                            style={{ display: "block" }}
                          >
                            {this.state.errors.guardianPhone}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col xs={12} sm={3}>
                      <Form.Group>
                        <Form.Label>Date:</Form.Label>
                        <Form.Control value={moment().format("MM/DD/YYYY")} />
                      </Form.Group>
                    </Col>
                  </Row>
                </>
              ) : (
                ""
              )}
              <Row>
                <Col xs={12} sm={3}>
                  <Form.Group>
                    <Form.Label>
                      {transaction.hasGuardian
                        ? "Guardian Signature"
                        : "Client Signature"}
                    </Form.Label>
                    <div
                      style={{
                        border: "solid 1px lightgray",
                        width: "100%",
                        height: "70px",
                        overflow: "hidden",
                      }}
                    >
                      <SignaturePad
                        canvasProps={{
                          width: 500,
                          height: 100,
                          className: "sigCanvas",
                        }}
                      />
                    </div>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </div>

          <FormActionPrompt
            transaction={this.state.transaction}
            promptType={this.state.promptType}
            showPrompt={this.state.showPrompt}
            exportFormToPDF={this.exportFormToPDF.bind(this)}
            sendForm={this.sendForm.bind(this)}
            handleClosePrompt={this.handleClosePrompt.bind(this)}
            clearTransactionSelection={this.clearTransactionSelection.bind(
              this
            )}
          />
          <GenerateQRcode
            transaction={this.state.transaction}
            formType="consent"
            showQRcodePrompt={this.state.showQRcodePrompt}
            handleCloseQRcodePrompt={this.handleCloseQRcodePrompt.bind(this)}
          />
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    contacts: state.reducer.contacts,
    roles: state.reducer.roles,
    transactions: state.reducer.transactions,
    vendorTransactions: state.reducer.vendorTransactions,
    buyerTransactions: state.reducer.buyerTransactions,
    tasks: state.reducer.tasks,
    addPublicFormData: state.reducer.addPublicFormData,
  };
};

export default connect(
  mapStateToProps,
  {
    getAllTransactionsAction,
    getVendorTransactionsAction,
    getBuyerTransactionsAction,
    getContactsActions,
    getUserRolesAction,
    getAllTasksAction,
    addDocAction,
    uploadDocumentAction,
    createTaskAction,
    addPublicFormAction,
  }
)(ConsentForm);
